import { render, staticRenderFns } from "./Luck2Draw.vue?vue&type=template&id=5eb1e187&scoped=true&"
import script from "./Luck2Draw.vue?vue&type=script&lang=js&"
export * from "./Luck2Draw.vue?vue&type=script&lang=js&"
import style0 from "./Luck2Draw.vue?vue&type=style&index=0&id=5eb1e187&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb1e187",
  null
  
)

export default component.exports